import { Button, Flex } from '@chakra-ui/react'
import { JSX, useMemo, useState } from 'react'
import { EncounterPreview } from '../../../../charting/Encounters/EncounterPreview'
import { EncounterViewModal } from '../../../../charting/Encounters/EncounterViewModal'
import { useProfile } from '../../../../contexts/user/ProfileContext'
import { ViewMoreButton } from '../../../Buttons/ViewMoreButton'
import { Loading } from '../../../Loading'

export const PatientEncountersSummary = () => {
  const {
    userId,
    goTo: onTabSelect,
    encounters: { dataArr: encountersArr, loading },
  } = useProfile()

  const [expanded, setExpanded] = useState(false)
  const [openEncounterId, setOpenEncounterId] = useState<string | null>(null)

  const sortedEncounters = useMemo(() => {
    if (!encountersArr?.length) return []
    return [...encountersArr].sort((a, b) => {
      const aDate = a.date ? new Date(a.date).getTime() : 0
      const bDate = b.date ? new Date(b.date).getTime() : 0
      return bDate - aDate
    })
  }, [encountersArr])

  const { mostRecentEncounter, otherEncounters } = useMemo(() => {
    if (!sortedEncounters.length) return { mostRecentEncounter: null, otherEncounters: [] }
    return { mostRecentEncounter: sortedEncounters[0], otherEncounters: sortedEncounters.slice(1) }
  }, [sortedEncounters])

  const encounterCount = encountersArr?.length ?? 0
  const showExpandCollapse = encounterCount > 1

  let body: JSX.Element | null = null
  if (loading && !encountersArr?.length) {
    body = <Loading text="Loading Visits" />
  } else {
    body = (
      <>
        <Flex px={2} w="100%" alignItems="center">
          <Button
            variant="link"
            color="gray.600"
            fontFamily="Open Sans"
            onClick={() => {
              onTabSelect({ entity: { type: 'patient' }, tab: 'gyn/encounters' })
            }}>
            Encounters ({encounterCount})
          </Button>
          {showExpandCollapse ? (
            <ViewMoreButton onClick={() => setExpanded(!expanded)}>
              {!expanded ? '+ View All' : '- Collapse'}
            </ViewMoreButton>
          ) : null}
        </Flex>
        <Flex flexFlow="column" gap={1} w="100%" maxH="300px" px={1.5} overflowY="auto">
          {mostRecentEncounter ? (
            <Flex px={1} w="100%">
              <EncounterPreview
                encounter={mostRecentEncounter}
                onClick={() => setOpenEncounterId(mostRecentEncounter.id)}
              />
            </Flex>
          ) : null}
          {showExpandCollapse ? (
            <Flex flexFlow="column" gap={1} p={0.5} w="100%">
              {otherEncounters.map(encounter => (
                <EncounterPreview
                  key={encounter.id}
                  encounter={encounter}
                  onClick={() => setOpenEncounterId(encounter.id)}
                />
              ))}
            </Flex>
          ) : null}
        </Flex>
      </>
    )
  }

  return (
    <Flex align="flex-start" py={2} gap={1} alignItems="center" flexFlow="column" w="100%">
      {body}
      {openEncounterId && userId ? (
        <EncounterViewModal
          examId={openEncounterId}
          patientId={userId}
          onClose={() => setOpenEncounterId(null)}
        />
      ) : null}
    </Flex>
  )
}
